import React from "react";
import { Box, Typography } from "@mui/material";
import theme from "@/theme";

interface SimpleHeaderProps {
  title: string;
  borderBottom?: boolean;
  padding?: string;
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({
  title,
  borderBottom = true,
  padding = "0 20px",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "54px",
        padding,
        backgroundColor: theme.palette.custom.mainWhite,
        borderBottom: borderBottom ? "1px solid #F4F5F6" : "none",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "24px",
          letterSpacing: 0,
          whiteSpace: "nowrap",
          color: theme.palette.custom.blueGray900,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default SimpleHeader;
